import { Form, InputNumber } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../constants/forms/validation/rules'

interface WidthProps {
    onChange: (value: number | null) => void
}

const Width: FC<WidthProps> = ({ onChange }) => {
    return (
        <Form.Item name={'width'} label={'Ширина'} rules={requiredInputNumberRules}>
            <InputNumber onChange={onChange} />
        </Form.Item>
    )
}

export default Width
